import http from './httpService';

export function getAllLossReasons() {
    return http.get(`/loss-reasons`);
}

export function createLossReason(payload) {
    return http.post(`/loss-reasons`, payload);
}

export function updateLossReason(payload,id) {
    return http.put(`/loss-reasons/${id}`, payload);
}

export function deleteLossReason(id) {
    return http.delete(`/loss-reasons/${id}`);
}
